// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import moment from 'moment-timezone'
import XRegExp from 'xregexp'
import { dateFormat } from 'helpers/regex'
import { ifObjectGetValue } from 'helpers/reduxFormFunctions'

// takes an epoch date an returns that date as YYYY/MM/DD
// returns null if v is not an epoch date
export const epochToYYYYMMDD = v => (
  typeof v === 'number' && !isNaN(v) && !isNaN(new Date(v).valueOf())
    ? moment(v).format('YYYY/MM/DD')
    : null
)

// same as above but interprets the value as EST
export const epochToYYYYMMDDinEST = v => (
  typeof v === 'number' && !isNaN(v) && !isNaN(new Date(v).valueOf())
    ? moment(v).tz('America/New_York').format('YYYY/MM/DD')
    : null
)

// same as above but interprets the value as EST
export const epochToYYYYMMDDHHMMSSinEST = v => (
  typeof v === 'number' && !isNaN(v) && !isNaN(new Date(v).valueOf())
    ? moment(v).tz('America/New_York').format('YYYY/MM/DD HH:mm:ss')
    : null
)

// makes a simple timestamp object which will be displayed in the UI.
export const makeTimestamp = (t, u) => ({
  timestamp: (
    t !== null
      ? moment(t).format('YYYY/MM/DD')
      : 'n/a'
  ),
  user: ifObjectGetValue(u, 'userName'),
})

// takes a string date as YYYY/MM/DD and returns the epoch date
export const YYYYMMDDtoEpoch = v => {
  const n = XRegExp.exec(v, dateFormat)
  const m = moment(v, 'YYYY/MM/DD')
  return (
    n && m.isValid()
      ? m.valueOf()
      : null
  )
}

// same as above but interprets it as EST.
export const YYYYMMDDtoEpochInEST = v => {
  const n = XRegExp.exec(v, dateFormat)
  const m = moment.tz(v, 'YYYY/MM/DD', 'America/New_York')
  return (
    n && m.isValid()
      ? m.valueOf()
      : null
  )
}
